import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36a502d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["srcset"]
const _hoisted_2 = ["src"]

import { computed, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useHome, useInfo } from '@/store';
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue.js';
import { Navigation, EffectFade, Swiper as typeofSwiper } from 'swiper';
import 'swiper/swiper-bundle.css';

export default /*#__PURE__*/_defineComponent({
  __name: 'EventsYear',
  setup(__props) {

_useCssVars(_ctx => ({
  "34eb5f68": (_unref(rouletteUpArrow).pc),
  "03961f97": (_unref(rouletteUpArrow).mobile),
  "7df3e52f": (_unref(rouletteDownArrow).pc),
  "346f2c44": (_unref(rouletteDownArrow).mobile)
}))

const { annualTimeline } = storeToRefs(useHome());
const { setCurrentYear, setActiveIndex } = useHome();
const deg = ref(0);
const rotateRoulette = (count = 0) => {
  deg.value += count;
};
const modules = [Navigation, EffectFade];
const navigation = {
  nextEl: '.swiper-button-next',
  prevEl: '.swiper-button-prev',
};
const onSlideChange = (swiper: typeofSwiper) => {
  setActiveIndex(0);
  setCurrentYear(annualTimeline['value'][swiper.activeIndex]['year']);
};
const { getImg } = useInfo();
const roulette = computed(() => ({
  pc: getImg('home_pc_roulette'),
  mobile: getImg('home_mobile_roulette'),
}));
const rouletteUpArrow = computed(() => ({
  pc: `url(${getImg('home_pc_roulette_up_arrow')})`,
  mobile: `url(${getImg('home_mobile_roulette_up_arrow')})`,
}));
const rouletteDownArrow = computed(() => ({
  pc: `url(${getImg('home_pc_roulette_down_arrow')})`,
  mobile: `url(${getImg('home_mobile_roulette_down_arrow')})`,
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Swiper), {
    navigation: navigation,
    modules: modules,
    effect: 'fade',
    onSlideChange: onSlideChange
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(annualTimeline), (time, index) => {
        return (_openBlock(), _createBlock(_unref(SwiperSlide), { key: index }, {
          default: _withCtx(() => [
            _createElementVNode("time", null, _toDisplayString(time.year), 1)
          ]),
          _: 2
        }, 1024))
      }), 128)),
      _createElementVNode("picture", {
        class: "roulette",
        style: _normalizeStyle(`transform: rotate(${deg.value}deg)`)
      }, [
        _createElementVNode("source", {
          srcset: _unref(roulette).pc || '',
          media: "(min-width: 751px)"
        }, null, 8, _hoisted_1),
        _createElementVNode("img", {
          src: _unref(roulette).mobile || '',
          alt: ""
        }, null, 8, _hoisted_2)
      ], 4),
      _createElementVNode("div", {
        class: "swiper-button-next",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (rotateRoulette(-90)))
      }),
      _createElementVNode("div", {
        class: "swiper-button-prev",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (rotateRoulette(90)))
      })
    ]),
    _: 1
  }))
}
}

})